import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ScholarshipManagementStoreActions,
  ScholarshipManagementStoreSelectors,
  ScholarshipManagementStoreReducer,
} from './index';
import { ScholarshipManagementDto } from '@cradua/data';

@Injectable()
export class ScholarshipManagementFacade {
  constructor(
    private store: Store<
      ScholarshipManagementStoreReducer.ScholarshipManagementPartialState
    >
  ) {}

  scholarshipManagementRecord$ = this.store.select(
    ScholarshipManagementStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ScholarshipManagementStoreSelectors.getSearchStudentRecord
  );

  scholarshipManagementRecordError$ = this.store.select(
    ScholarshipManagementStoreSelectors.getScholarshipManagementError
  );

  getselected() {
    return this.store.select(ScholarshipManagementStoreSelectors.getSelected);
  }

  get isLoadingScholarshipManagement() {
    this.store.dispatch(
      ScholarshipManagementStoreActions.loadScholarshipManagement()
    );
    return this.store.select(
      ScholarshipManagementStoreSelectors.loadingScholarshipManagement
    );
  }

  get loadScholarshipManagement() {
    this.store.dispatch(
      ScholarshipManagementStoreActions.loadScholarshipManagement()
    );
    return this.store.select(
      ScholarshipManagementStoreSelectors.getAllScholarshipManagement
    );
  }

  searchStudentRecord(query) {
    this.store.dispatch(
      ScholarshipManagementStoreActions.searchScholarshipManagementRecord({
        query,
      })
    );
  }

  addScholarshipManagement(newScholarshipManagement: ScholarshipManagementDto) {
    this.store.dispatch(
      ScholarshipManagementStoreActions.addScholarshipManagement({
        newScholarshipManagement,
      })
    );
  }

  uploadExcelScholarshipManagement(
    uploadExcelRecord: ScholarshipManagementDto[]
  ) {
    this.store.dispatch(
      ScholarshipManagementStoreActions.uploadExcelStudentRecord({
        uploadExcelRecord,
      })
    );
  }

  updateScholarshipManagement(
    updateScholarshipManagement: ScholarshipManagementDto
  ) {
    this.store.dispatch(
      ScholarshipManagementStoreActions.updateScholarshipManagement({
        updateScholarshipManagement,
      })
    );
  }

  removeScholarshipManagement(ids: string) {
    this.store.dispatch(
      ScholarshipManagementStoreActions.removeScholarshipManagement({ ids })
    );
  }
}
